export default "__VITE_ASSET__iTZ4xzI2__"